import React from "react";
import Main from "./main";
import Header from "../../components/Header/Header.jsx";

function Layout({ open }) {
  return (
    <>
      <div
        className=""
        style={{ width: open ? "88%" : "89%", margin: "20px auto" }}
      >
        <Header />
      </div>
      <div
        className="pt-8 sm:h-screen bg-gray-200 shadow-2xl shadow-slate-800 px-6 sm:px-20 rounded-md mt-16"
        // style={{ width: open ? "95%" : "100%" }}
        style={{ width: "95%", margin:"auto" }}
      >
        <Main />
      </div>
    </>
  );
}

export default Layout;
